import { render, staticRenderFns } from "./CardLinkTab.vue?vue&type=template&id=3d788b3a&"
import script from "./CardLinkTab.vue?vue&type=script&lang=js&"
export * from "./CardLinkTab.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports